import type { WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';

export const getCmdbRestBaseUrl = (workspaceId: WorkspaceId) =>
	`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;
